module.exports = __webpack_public_path__ + "img/Mstorybg304.85eb7542.png";